import { Injectable } from '@angular/core';
import { OnFieldChanged } from '../../../../../shared/modules/configurable-form/models/on-field-changed';
import { UntypedFormGroup } from '@angular/forms';
import * as moment from 'moment';
import { SpecFieldNames } from '../../constants/specification-field-names.enum';

@Injectable()
export class SetTimepickerDateFromDatepickerCommand implements OnFieldChanged {
  onFieldChanged(value: any, formGroup: UntypedFormGroup): void {
    const date = moment(value);

    const timeControl = formGroup.get(SpecFieldNames.TIME);

    if (timeControl === null) {
      return;
    }

    if (timeControl.value === undefined) {
      return;
    }

    const hours = typeof timeControl.value.hours === 'function' ? timeControl.value.hours() : timeControl.value.hours;
    const minutes =
      typeof timeControl.value.minutes === 'function' ? timeControl.value.minutes() : timeControl.value.minutes;
    if (hours === undefined) {
      return;
    }
    date.hours(hours);
    date.minutes(minutes);
    timeControl.setValue(date);
  }
}
